import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import Add from "./Layout/Manager/Client.feat/Add";
import ClientInfo from "./Layout/Manager/Client.feat/Update";
import Clients from "./Layout/Manager/Clients";
import License from "./Layout/Manager/License";
import ParkingLots from "./Layout/Manager/ParkingLots";
import TimeLog from "./Layout/Manager/TimeLog";
import ClientPage from "./Page/Client/Client";
import Error from "./Page/Error/Error";
import LoginPage from "./Page/Login";
import Manager from "./Page/Manager/Manager";
import Register from "./Page/Register";
import Profile from "./Layout/Client/Profile";
import Vehicle from "./Layout/Client/Vehicle";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/Manager/Login" element={<LoginPage role={1} />} />
        <Route path="/Manager" element={<Manager />}>
          <Route path="*" element={<Error />}></Route>
          <Route path="License" index element={<License />} />
          <Route path="Clients" element={<Clients />}>
            <Route path="new" element={<Add />} />
          </Route>
          <Route path="Clients/:clientId" element={<ClientInfo />} />
          <Route path="TimeLog" element={<TimeLog />} />
          <Route path="Parking" element={<ParkingLots />} />
        </Route>
        <Route path="/Client/Login" element={<LoginPage role={2} />}></Route>
        <Route path="/Client/Register" element={<Register role={2} />}></Route>
        <Route path="/Client/" element={<ClientPage />}>
          <Route path="*" element={<Error />}></Route>
          <Route path="Profile" element={<Profile />} />
          <Route path="Parking" element={<ParkingLots />} />
          <Route path="Vehicle" element={<Vehicle />} />
        </Route>
        <Route path="*" element={<Navigate to="/Client" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
//add
//delete
export default App;
